import { render, staticRenderFns } from "./OffersCard.vue?vue&type=template&id=584e3cd0&scoped=true"
import script from "./OffersCard.vue?vue&type=script&lang=js"
export * from "./OffersCard.vue?vue&type=script&lang=js"
import style0 from "./OffersCard.vue?vue&type=style&index=0&id=584e3cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e3cd0",
  null
  
)

export default component.exports